import React, { useEffect, useState } from "react";
import axios from "axios";
import Grid from "../components/Grid";
import QuestionList from "../components/QuestionList";
import CheckButton from "../components/CheckButton";
import GameStatus from "../components/GameStatus";
import { API_URL } from "../components/Constant";

function English() {
  const [questions, setQuestions] = useState([]);
  const [grid, setGrid] = useState(
    Array(7)
      .fill("")
      .map(() => Array(8).fill("")),
  );
  const [userAnswers, setUserAnswers] = useState([]); // To store answers entered by the user
  const [isChecked, setIsChecked] = useState(false);
  const [score, setScore] = useState(0);
  const [cellColors, setCellColors] = useState({}); // To store the color of each cell

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const response = await axios.post(`${API_URL}/questions`, {
          language: "English",
        });
        console.log(response.data);
        setQuestions(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchQuestions();
  }, []);

  const handleAnswerChange = (e, cellIndex, questionNumber) => {
    const updatedAnswers = [...userAnswers];

    const answerIndex = updatedAnswers.findIndex(
      (ans) => ans.question_number === questionNumber,
    );

    if (answerIndex !== -1) {
      updatedAnswers[answerIndex] = {
        // Update the existing entry
        question_number: questionNumber,
        answer: e.target.value,
      };
    } else {
      updatedAnswers.push({
        // Add a new entry
        question_number: questionNumber,
        answer: e.target.value,
      });
    }

    setUserAnswers(updatedAnswers); // Update the state with the new answer
  };

  const continueGame = () => {
    // Reset the game state but keep the current grid
    setIsChecked(false); // Uncheck answers
    setUserAnswers([]); // Clear user answers
    setScore(0); // Optionally reset score if you want to
  };

  const [dummyState, setDummyState] = useState(0);

  const quitGame = () => {
    setIsChecked(false); // Uncheck answers
    setUserAnswers([]); // Clear user answers
    setScore(0); // Reset score
    setGrid(
      Array(8)
        .fill("")
        .map(() => Array(8).fill("")),
    ); // Reset grid to empty values
    setDummyState(dummyState + 1); // Trigger a dummy state change to force re-render
  };

  return (
    <div className="App">
      <h1>Crossword Game</h1>
      <div style={{ display: "flex", marginLeft: "5%" }}>
        {/* <Grid grid={grid} questions={questions} setGrid={setGrid} handleAnswerChange={handleAnswerChange} /> */}
        <Grid grid={grid} setGrid={setGrid} cellColors={cellColors} />
        <QuestionList questions={questions} />
      </div>
      <CheckButton
        userAnswers={userAnswers}
        setCellColors={setCellColors}
        setIsChecked={setIsChecked}
        setScore={setScore}
        grid={grid}
        questions={questions}
      />
      {isChecked && (
        <GameStatus
          score={score}
          continueGame={continueGame}
          quitGame={quitGame}
        />
      )}
    </div>
  );
}

export default English;
